import { FC, useEffect, useState } from "react";
import { Wrapper } from "./styled";
import { setIntoLocalStorage, getFromLocalStorage } from "./lib/utils";
import Header from "./ui/Header";
import EmployeesTabs from "./ui/EmployeesTabs";
import Table from "./ui/Table";
import SelectedEmployee from "./ui/SelectedEmployee";
import Footer from "./ui/Footer";

const EmployeesTable: FC = () => {
  const [tab, setTab] = useState(
    getFromLocalStorage("tab") ? Number(getFromLocalStorage("tab")) : 0
  );
  const [selectedEmployees, setSelectedEmployees] = useState<
    {
      Id: string;
      Name: string;
      Surname: string;
      Patronymic: string;
      EmploymentDate: string;
      Section: string;
      WorkPosition: string;
      DismissDate: string;
      WorkType: string;
    }[]
  >(
    getFromLocalStorage("selectedEmployees")
      ? JSON.parse(String(getFromLocalStorage("selectedEmployees")))
      : []
  );
  const [menuItem, setMenuItem] = useState(
    getFromLocalStorage("menuItem")
      ? String(getFromLocalStorage("menuItem"))
      : ""
  );

  const handleMenuItem = (menuItem: string) => setMenuItem(menuItem);

  useEffect(() => {
    setIntoLocalStorage("tab", tab);
  }, [tab]);

  useEffect(() => {
    setTab( selectedEmployees.length);
    setIntoLocalStorage("selectedEmployees", JSON.stringify(selectedEmployees));
  }, [selectedEmployees]);

  useEffect(() => {
    setIntoLocalStorage("menuItem", menuItem);
  }, [menuItem]);

  return (
    <Wrapper>
      <Header />
      <EmployeesTabs
        tab={tab}
        setTab={setTab}
        selectedEmployees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
      />
      {tab === 0 ? (
        <Table
          selectedEmployees={selectedEmployees}
          setSelectedEmployees={setSelectedEmployees}
        />
      ) : (
        <SelectedEmployee
          handleMenuItem={handleMenuItem}
          selectedEmployees={selectedEmployees}
          tab={tab}
          menuItem={menuItem}
        />
      )}
      <Footer />
    </Wrapper>
  );
};

export default EmployeesTable;
